import { MIN_THUMB_WIDTH } from "./constants";

export const calculateThumbLeft = (deltaX: number, prevThumbWidth: number, prevThumbLeft: number): number => {
  const newLeft = prevThumbLeft + deltaX;
  return Math.min(Math.max(newLeft, 0), prevThumbLeft + prevThumbWidth - MIN_THUMB_WIDTH);
};
